import { render, staticRenderFns } from "./Manage-Retire-Reason.vue?vue&type=template&id=85069650"
import script from "./Manage-Retire-Reason.vue?vue&type=script&lang=js"
export * from "./Manage-Retire-Reason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports